const env = process.env;
const API = `${env.VUE_APP_BACKEND_URL}`;
export default API;